module.exports = __webpack_public_path__ + "img/default.e746f9b7.jpg";